import './profile.css';

import React from "react";

import { Table } from 'antd';

import _1 from '../../assets/images/content/_4.jpg';

import SideNav from "./sidenav";
import Order from '../../assets/images/shop/profile.svg';
import Nav from '../../utils/nav';
import Footer from '../../utils/footer';
import { Link } from 'react-router-dom';

const TransactionHistory = () => {

    const columns = [
        {
            title: '',
            dataIndex: 'sn',
        },
        {
            title: 'Product',
            dataIndex: 'name',
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            align: 'right',
        },
        {
            title: 'Cash Assets',
            sn: 1,
            Name: 'column-money',
            dataIndex: 'money',
            align: 'right',
        },
        {
            title: 'Transaction Id',
            dataIndex: 'transId',
        },
        {
            title: '',
            dataIndex: 'action',
        },
    ];
    const data = [
        {
            key: '1',
            // 'Carta Coffee Table'
            sn: 1,
            name: <div className="order-history-img-flex">
                <img src={_1} alt="product" />
                <h3>Carta Coffee Table</h3>
            </div>,
            money: '₦ 300,000.00',
            quantity: 2,
            transId: '923u-2u92-u92u-4241',
            action: <Link to="/">See More</Link>
        },
        {
            key: '2',
            sn: 2,
            name: <div className="order-history-img-flex">
                <img src={_1} alt="product" />
                <h3>Carta Coffee Table</h3>
            </div>,
            money: '₦ 1,256,000.00',
            quantity: 2,
            transId: '923u-2u92-u92u-4241',
            action: <Link to="/">See More</Link>
        },
        {
            key: '3',
            sn: 3,
            name: <div className="order-history-img-flex">
                <img src={_1} alt="product" />
                <h3>Carta Coffee Table</h3>
            </div>,
            money: '₦ 120,000.00',
            quantity: 2,
            transId: '923u-2u92-u92u-4241',
            action: <Link to="/">See More</Link>
        },
    ];

    return (
        <div>
            <Nav />
            <div className="main_info">
                <SideNav />
                <div className="profile_data">
                    <div className="profile-data-display">
                        <div>
                            <h3>Order History</h3>
                            <Table
                                columns={columns}
                                dataSource={data}
                                bordered
                                title={null}
                                footer={null}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default TransactionHistory;